import { type AlertVariants, alertVariants } from '@ev-tech/ui-core-components/Alert';

export const PROLONG_NOTIFICATION_PARAM = 'prolongNotification';
export const PROLONG_ALERT_PARAM = 'prolongAlert';
export const AUTH_KEY_PARAM = 'authKey';

export const ProlongIntentKind = {
  NONE: 'none',
  SHOW_NOTIFICATION: 'showNotification',
  PROLONG_ALERT: 'prolongAlert',
} as const;

export type ProlongIntentKind = (typeof ProlongIntentKind)[keyof typeof ProlongIntentKind];

export type ProlongIntent =
  | { kind: typeof ProlongIntentKind.NONE }
  | { kind: typeof ProlongIntentKind.SHOW_NOTIFICATION; notification: AlertVariants }
  | { kind: typeof ProlongIntentKind.PROLONG_ALERT; alertId: string; authKey: string };

export const readProlongIntent = (query: URLSearchParams): ProlongIntent => {
  const notificationAlert = query.get(PROLONG_NOTIFICATION_PARAM);
  if (notificationAlert === alertVariants.success || notificationAlert === alertVariants.error) {
    return { kind: ProlongIntentKind.SHOW_NOTIFICATION, notification: notificationAlert };
  }

  const prolongAlert = query.get(PROLONG_ALERT_PARAM);
  const authKey = query.get(AUTH_KEY_PARAM);

  if (!prolongAlert || !authKey) {
    return { kind: ProlongIntentKind.NONE };
  }

  return { kind: ProlongIntentKind.PROLONG_ALERT, alertId: prolongAlert.trim(), authKey };
};

export const removeQueryParams = (query: URLSearchParams, paramNames: string[]) => {
  paramNames.forEach((paramName) => query.delete(paramName));
  const search = query.toString();
  window.history.replaceState({}, '', search ? `${window.location.pathname}?${search}` : window.location.pathname);
};

export const showNotificationAndRemoveParams = (notification: AlertVariants, showNotification: (notification: AlertVariants) => void) => {
  const query = new URLSearchParams(window.location.search);
  showNotification(notification);
  removeQueryParams(query, [PROLONG_ALERT_PARAM, AUTH_KEY_PARAM]);
};
